export default "__VITE_ASSET__69e32fca__"